<template>
  <div class="tpp-page">
    <nearby-housekeeping-ops-nav active-path="/pages/tpp/nearby-housekeeping/payments" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head">
        <div><h2 class="tpp-panel__title">收款配置</h2><p class="tpp-muted">只引用支付池。生产启用需要另一名管理员复核。历史订单继续使用冻结版本。</p></div>
        <el-button type="primary" size="small" @click="open">新建版本</el-button>
      </div>
      <el-table :data="rows" v-loading="loading" border>
        <el-table-column prop="environment" label="环境" width="90" />
        <el-table-column prop="bindingVersion" label="版本" width="80" />
        <el-table-column prop="settlementMode" label="结算模式" min-width="180" />
        <el-table-column prop="refundMode" label="退款模式" width="140" />
        <el-table-column prop="mchIdMask" label="商户号" width="140" />
        <el-table-column prop="subMchIdMask" label="子商户号" width="140" />
        <el-table-column prop="ppId" label="支付池" min-width="140" />
        <el-table-column prop="payeeDisplayName" label="收款方" width="120" />
        <el-table-column prop="bindingStatus" label="状态" width="110" />
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="text" @click="verify(scope.row)">验证</el-button>
            <el-button type="text" @click="activate(scope.row)">启用</el-button>
            <el-button type="text" @click="retire(scope.row)">退役</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <el-dialog title="新建收款绑定" :visible.sync="visible" width="640px">
      <el-form label-width="120px">
        <el-form-item label="环境">
          <el-input :value="form.environment" disabled />
          <div class="tpp-tip">跟随配置中心 HC_ENV（DEV/TEST→TEST，其余→PROD），不可在此切换。</div>
        </el-form-item>
        <el-form-item label="支付池 ID"><el-input v-model.trim="form.ppId" /></el-form-item>
        <el-form-item label="结算模式"><el-select v-model="form.settlementMode"><el-option label="普通商户" value="DIRECT_MERCHANT" /><el-option label="服务商子商户" value="SERVICE_PROVIDER_SUB_MERCHANT" /></el-select></el-form-item>
        <el-form-item label="退款模式"><el-select v-model="form.refundMode"><el-option label="本平台渠道退款" value="LOCAL_CHANNEL" /><el-option label="三方退款接口" value="PROVIDER_API" /></el-select></el-form-item>
        <el-form-item label="商户号"><el-input v-model.trim="form.mchIdMask" /><div class="tpp-tip">保存后只显示掩码。</div></el-form-item>
        <el-form-item label="子商户号"><el-input v-model.trim="form.subMchIdMask" /></el-form-item>
        <el-form-item label="收款方名称"><el-input v-model.trim="form.payeeDisplayName" /></el-form-item>
        <el-form-item label="配置摘要"><el-input v-model.trim="form.configDigest" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="visible=false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存草稿</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import NearbyHousekeepingOpsNav from './nearbyHousekeepingNav.vue'
import { nearbyHousekeepingOpsMixin } from './nearbyHousekeepingOpsMixin'
import { listNearbyHousekeepingPayments, saveNearbyHousekeepingPayment, verifyNearbyHousekeepingPayment, activateNearbyHousekeepingPayment, retireNearbyHousekeepingPayment, getNearbyHousekeepingSummary, nhPayload } from '@/api/tpp/nearbyHousekeepingOpsApi'
import '../tpp.scss'
export default {
  name: 'NearbyHousekeepingPayments',
  components: { NearbyHousekeepingOpsNav },
  mixins: [nearbyHousekeepingOpsMixin],
  data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      rows: [],
      form: {
        environment: 'TEST',
        ppId: '',
        settlementMode: 'DIRECT_MERCHANT',
        refundMode: 'LOCAL_CHANNEL',
        mchIdMask: '',
        subMchIdMask: '',
        payeeDisplayName: '附近家政',
        configDigest: ''
      }
    }
  },
  async created() { if (await this.ensureNearbyHousekeepingPlatform()) this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const summary = nhPayload(await getNearbyHousekeepingSummary({ platformId: this.platformId }))
        const access = (summary && summary.accessConfig) || {}
        if (access.environment) this.form.environment = access.environment
        this.rows = (await listNearbyHousekeepingPayments({ platformId: this.platformId, page: 1, row: 100 })).data || []
      } catch (e) { this.$message.error(e.message || '收款配置加载失败') }
      finally { this.loading = false }
    },
    open() { this.visible = true },
    async save() {
      this.saving = true
      try {
        await saveNearbyHousekeepingPayment({ ...this.form, platformId: this.platformId })
        this.visible = false
        this.$message.success('收款绑定已保存')
        await this.load()
      } catch (e) { this.$message.error(e.message || '保存失败') }
      finally { this.saving = false }
    },
    async verify(row) {
      try {
        const evidence = await this.$prompt('填写到账或授权验证证据', '验证收款绑定', { inputPattern: /\S+/, inputErrorMessage: '请填写证据' })
        await verifyNearbyHousekeepingPayment({ platformId: this.platformId, bindingId: row.bindingId, evidence: evidence.value })
        this.$message.success('已标记为已验证')
        this.load()
      } catch (e) { if (e !== 'cancel') this.$message.error(e.message || '验证失败') }
    },
    async activate(row) {
      try {
        await activateNearbyHousekeepingPayment({ platformId: this.platformId, bindingId: row.bindingId })
        this.$message.success('收款绑定已启用')
        this.load()
      } catch (e) { this.$message.error(e.message || '启用失败') }
    },
    async retire(row) {
      try {
        await retireNearbyHousekeepingPayment({ platformId: this.platformId, bindingId: row.bindingId })
        this.$message.success('收款绑定已退役')
        this.load()
      } catch (e) { this.$message.error(e.message || '退役失败') }
    }
  }
}
</script>
